import { IconButton } from '@mui/material'
import { PageHeader, PageContent } from 'layout'
import { Breadcrumbs, BreadcrumbsPath } from 'components'
import { ReactNode } from 'react'
import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'

type Props = {
  title: string
  helmetTitle?: string
  CustomHelmet?: ReactNode
  path?: string[]
  children: ReactNode
  pathArray: BreadcrumbsPath[]
  backButtonNavigation?: string
  HeaderRight?: ReactNode
  backButtonAlertMessage?: string
}

export const BasePage = (props: Props) => {
  const {
    children,
    helmetTitle,
    title,
    CustomHelmet,
    pathArray,
    backButtonNavigation = '',
    backButtonAlertMessage,
    HeaderRight
  } = props
  const navigation = useNavigate()

  return (
    <>
      {CustomHelmet && CustomHelmet}
      {!CustomHelmet && (
        <Helmet>
          <title>{helmetTitle || title || ''}</title>
        </Helmet>
      )}
      <PageHeader>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: 91
          }}
        >
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}
            >
              {backButtonNavigation && (
                <IconButton
                  onClick={() => {
                    if (backButtonAlertMessage) {
                      if (confirm(backButtonAlertMessage))
                        navigation(backButtonNavigation)
                    } else {
                      navigation(backButtonNavigation)
                    }
                  }}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <MdKeyboardArrowLeft
                    size={24}
                    color="#565656"
                    style={{ background: '' }}
                  />
                </IconButton>
              )}
              <div
                style={{ marginLeft: '1rem', fontSize: 20, fontWeight: 800 }}
              >
                {title}
              </div>
            </div>
            <Breadcrumbs
              pathArray={pathArray}
              aria-label="breadcrumbOrder"
              style={{ marginLeft: backButtonNavigation ? 56 : 16 }}
            />
          </div>
          <div style={{ flex: 1 }}>{HeaderRight}</div>
        </div>
      </PageHeader>
      <PageContent>{children}</PageContent>
    </>
  )
}
